// components/NavBar.js
import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

import wordmark from '../assets/menu-wordmark.jpg';

function NavBar() {
  const navigate = useNavigate();
	const { token, is_superadmin, logout } = useAuth();

  // The AuthContext's logout, as Lead Barbarian's: the token revoked on the server, the login cleared, the login
  // screen opened
  const handleLogout = () => {
    logout();
  };

  // <Nav.Link href="/profile">Profile</Nav.Link>

  return (
    <Navbar expand="lg" fixed="top" className="navbar">
      <Container fluid className="navbar-container">
        <Navbar.Brand href="/">
            <img src={wordmark} className="nabar-logo"/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="cpp-navbar" />
        <Navbar.Collapse id="cpp-navbar">
          <Nav className="me-auto">
          </Nav>
          <Nav className="ms-auto">
			{token && <Nav.Link onClick={() => { navigate('/sites'); }}>Sites</Nav.Link>}
			{token && <Nav.Link onClick={() => { navigate('/chat'); }}>AEO Assistant</Nav.Link>}
			{token && <Nav.Link onClick={() => { navigate('/profile'); }}>Account</Nav.Link>}
			{token && is_superadmin && <Nav.Link onClick={() => { navigate('/superadmin'); }}>SuperAdmin</Nav.Link>}
			{token && <Nav.Link onClick={() => { navigate('/help/introduction'); }}>Help</Nav.Link>}
            {token && <Nav.Link onClick={handleLogout}>Log Out</Nav.Link>}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
